import { useEffect, useState } from 'react';

import { CHATBOT_FAQ_PADDING, MOBILE_BREAKPOINT } from '#/utils/constants';

export function useResponsiveLayout(faqQuestionId) {
  const [isResponsive, setIsResponsive] = useState(false);

  useEffect(() => {
    const resizeHandler = () => {
      setIsResponsive(window.innerWidth < MOBILE_BREAKPOINT);

      if (window.innerWidth < MOBILE_BREAKPOINT) {
        const content = document.querySelector('.content');
        const faqs = document.querySelector('.footer-faqs');
        const additionalNote = document.querySelector('.additional-note-wrapper');

        if (content) {
          const height =
            window.innerHeight - (faqs?.clientHeight || 0) - (additionalNote?.clientHeight || 0) - CHATBOT_FAQ_PADDING;
          content.style.height = `${height}px`;
        }
      } else {
        const content = document.querySelector('.content');
        if (content) {
          content.style.height = '';
        }
      }
    };

    window.addEventListener('resize', resizeHandler);
    resizeHandler();

    return () => window.removeEventListener('resize', resizeHandler);
  }, [faqQuestionId]);

  useEffect(() => {
    const html = document.documentElement;

    if (isResponsive) {
      document.body.style.overflow = 'hidden';
      document.body.style.height = '100vh';
      document.body.style.position = 'fixed';
      html.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
      document.body.style.height = '';
      document.body.style.position = '';
      html.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
      document.body.style.height = '';
      document.body.style.position = '';
      html.style.overflow = '';
    };
  }, [isResponsive]);

  return { isResponsive };
}
